/* eslint-disable no-unused-vars */
export default class BlogGrid extends window.HTMLElement {
  private isLoading = false;
  private currentPage = 1;
  private totalPages = 1;
  private hasNextPage = false;

  constructor() {
    super();
    this.initializePaginationData();
    this.setupLoadMoreButton();

    requestAnimationFrame(() => {
      this.removeAttribute('data-loading');
    });
  }

  private initializePaginationData() {
    const container = this.querySelector('#blog-grid-container') as HTMLElement;
    if (!container) return;

    this.currentPage = parseInt(container.dataset.currentPage || '1');
    this.totalPages = parseInt(container.dataset.totalPages || '1');
    this.hasNextPage = container.dataset.hasNextPage === '1';
  }

  private setupLoadMoreButton() {
    const button = this.querySelector('#load-more-button') as HTMLButtonElement;
    if (!button || !this.hasNextPage) return;

    button.addEventListener('click', () => {
      this.loadMoreArticles();
    });
  }

  private async loadMoreArticles() {
    if (this.isLoading || !this.hasNextPage) return;

    this.isLoading = true;
    const button = this.querySelector('#load-more-button') as HTMLButtonElement;
    const loadingText = button?.querySelector('[data-load-more-loading]');
    const normalText = button?.querySelector('[data-load-more-text]');

    try {
      if (button) {
        button.disabled = true;
        normalText?.classList.add('hidden');
        loadingText?.classList.remove('hidden');
      }

      const nextPage = this.currentPage + 1;
      const currentUrl = new URL(window.location.href);
      const searchParams = new URLSearchParams(currentUrl.search);

      searchParams.set('page', nextPage.toString());
      searchParams.set('section_id', this.dataset.id || '');
      const ajaxUrl = `${currentUrl.pathname}?${searchParams.toString()}`;

      const response = await fetch(ajaxUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      await this.appendArticles(html);

      this.currentPage = nextPage;
      this.hasNextPage = nextPage < this.totalPages;

      const container = this.querySelector('#blog-grid-container') as HTMLElement;
      if (container) {
        container.dataset.currentPage = this.currentPage.toString();
        container.dataset.hasNextPage = this.hasNextPage ? '1' : '0';
      }

      if (!this.hasNextPage && button) {
        button.parentElement?.remove();
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      this.showError();
    } finally {
      this.isLoading = false;
      if (button) {
        button.disabled = false;
        normalText?.classList.remove('hidden');
        loadingText?.classList.add('hidden');
      }
    }
  }

  private async appendArticles(html: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newArticles = doc.querySelectorAll('#article-list > li');
    const articleList = this.querySelector('#article-list');

    if (!articleList || !newArticles.length) return;

    newArticles.forEach((article) => {
      const articleElement = article.cloneNode(true) as HTMLElement;
      articleList.appendChild(articleElement);
    });
  }

  private showError() {
    const button = this.querySelector('#load-more-button');
    if (button?.parentElement) {
      button.parentElement.innerHTML = `
        <div class="flex items-center gap-2x text-red-600">
          <span class="text-sm">Failed to load more articles. <button class="underline font-medium" onclick="location.reload()">Refresh page</button></span>
        </div>
      `;
    }
  }
}

if (!customElements.get('blog-grid')) {
  window.customElements.define('blog-grid', BlogGrid);
}
